import { Component, inject, type OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SupportDataComponent } from '@components/support-data/support-data.component';

@Component({
  selector: 'app-support-dialog',
  imports: [SupportDataComponent, MatDialogModule],
  templateUrl: './support-dialog.component.html',
  styleUrl: './support-dialog.component.scss',
})
export class SupportDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<SupportDialogComponent>);

  ngOnInit() {
    this.dialogRef.addPanelClass('support-dialog');
  }

  close() {
    this.dialogRef.close();
  }
}
